import React, { useContext } from "react";
import globalComp from "../../../../global/components";
import { CanvasContext } from "../../provider";

interface TextEditActionsProps {
  handleActiveTextTools: any;
  handleObjectDelete: any;
  setting: string;
}

function TextEditActions({
  handleActiveTextTools,
  handleObjectDelete,
  setting,
}: TextEditActionsProps) {
  const { activeObject } = useContext(CanvasContext);
  return (
    <div className={"product-canvas__object-controls"}>
      <globalComp.ControlButton
        onClick={() => {
          handleActiveTextTools("family");
        }}
        imgName={"text-style.svg"}
        style={setting === "family" ? { borderColor: "white" } : {}}
      />

      <globalComp.ControlButton
        onClick={() => {
          handleActiveTextTools("color");
        }}
        imgName={"text-color.svg"}
        style={setting === "color" ? { borderColor: "white" } : {}}
      />

      <globalComp.ControlButton
        onClick={() => {
          handleActiveTextTools("size");
        }}
        imgName={"text-size.svg"}
        style={setting === "style" ? { borderColor: "white" } : {}}
      />

      <globalComp.ControlButton
        onClick={() => {
          handleActiveTextTools("weight");
        }}
        imgName={"text-bold.svg"}
        style={setting === "style" ? { borderColor: "white" } : {}}
      />

      <globalComp.ControlButton
        onClick={() => {
          handleActiveTextTools("style");
        }}
        imgName={"text-italic.svg"}
        style={setting === "style" ? { borderColor: "white" } : {}}
      />

      <globalComp.ControlButton
        onClick={() => {
          handleObjectDelete();
        }}
        imgName={"trash.svg"}
      />
    </div>
  );
}

export default TextEditActions;
